module.exports = __webpack_public_path__ + "img/L_314_0.85dc4823.png";